import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getReportParams({ commit }, data) {
      try {
        const response = await api.get(`/reports/params`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async searchGeneralReport({ commit }, data) {
      try {
        let queryString = ''
        if (data) {
          queryString = Object.keys(data)
            .map((key) => `${key}=${data[key]}`)
            .join('&')
        }
        const response = await api.get(`/reports/generals?${queryString}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async searchGripReport({ commit }, data) {
      try {
        let queryString = ''
        if (data) {
          queryString = Object.keys(data)
            .map((key) => `${key}=${data[key]}`)
            .join('&')
        }
        const response = await api.get(`/reports/grip?${queryString}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
